<ng-container *transloco="let translate; read: 'twoFaVerify'">
  <div class="row" *ngIf="!hideTitle">
    <div class="col-12">
      <div>
        <h5 class="text-primary">{{ translate('welcomeToHarmony') }}</h5>
        <p class="text-muted">{{ translate('verifyOTP') }}</p>
      </div>
    </div>
  </div>
  <form>
    <div class="row mb-3">
      <div class="col-12">
        <p class="mb-2">{{ translate('enter6DigitCode', {method: currentMethodLabel}) }}</p>
      </div>
      <div class="col-12 d-flex justify-content-center mb-3">
        <ng-otp-input [config]="config" (onInputChange)="onOtpChange($event)"></ng-otp-input>
      </div>
    </div>
    <div class="row justify-content-between mb-2">
      <div class="col mb-2">
        <button
          type="button"
          (click)="verifyOtp()"
          class="btn btn-primary w-100"
          [disabled]="loading || otp?.length < 6"
        >
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> {{ translate('verify') }}
        </button>
      </div>
      <div class="col-6 mb-2" *ngIf="!hideLogout">
        <button
          type="button"
          class="btn btn-secondary w-100"
          (click)="onLogout()"
          [disabled]="loading">
          <span transloco="header.user.logout"></span>
        </button>
      </div>
    </div>

    <div class="row mb-3">
      <ng-container *ngIf="timerActive; else resendSection">
        <div class="col-12 text-center text-muted">
          {{ translate('notReceivedOtp') }} {{ translate('timerMessage') }} <b #timer></b>
        </div>
      </ng-container>
      <ng-template #resendSection>
        <ng-container *ngIf="!showMethodSelector; else methodSelector">
          <ng-container *ngIf="availableProviders?.length > 1; else singleMethod">
            <div class="col-12 text-center">
              {{ translate('notReceivedOtp') }}
            </div>
            <div class="col-12 text-center">
              <button type="button" class="btn btn-link px-2 py-1" (click)="resend()">
                {{ translate('resendCode') }}
              </button>
              <span transloco="or"></span>
              <button type="button" class="btn btn-link px-2 py-1" (click)="toggleMethodSelector()">
                {{ translate('tryAnotherMethod') }}
              </button>
            </div>
          </ng-container>
          <ng-template #singleMethod>
            <div class="col-12 text-center" *ngIf="otpCooldownTime">
              {{ translate('notReceivedOtp') }}
              <button type="button" class="btn btn-link px-2 py-1" (click)="resend()">
                {{ translate('resendCode') }}
              </button>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #methodSelector>
          <div class="col-12 text-center mb-3">
            {{ translate('selectMethod') }}
            <div class="d-flex gap-2 justify-content-center flex-wrap mt-2">
              <button
                *ngFor="let method of availableProviders"
                type="button"
                class="btn btn-sm"
                [class.btn-primary]="selectedMethod === method"
                [class.btn-outline-primary]="selectedMethod !== method"
                (click)="selectMethod(method)"
              >
                <ng-container [ngSwitch]="method">
                  <span *ngSwitchCase="TwoFactorMethod.Email">{{ translate('email') }}</span>
                  <span *ngSwitchCase="TwoFactorMethod.SMS">{{ translate('sms') }}</span>
                </ng-container>
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <button type="button" class="btn btn-link px-2 py-1" (click)="resend()">
              {{ translate('resendCode') }}
            </button>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </form>
</ng-container>
